import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-dashboard',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.support.dashboard/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalLpsysadminSupportDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public data: any = {
        programs: { total: 0, recruiting: 0, evaluating: 0, operating: 0, completed: 0 },
        applications: { total: 0, screening: 0, doc_passed: 0, pt_passed: 0, selected: 0 },
        evaluators: { total: 0, active: 0 },
        operations: { active_review_mentoring: 0, active_program_modules: 0 },
        recent_programs: [],
        upcoming_milestones: [],
    };

    public statusMap: any = {
        draft: { label: '준비', cls: 'bg-zinc-100 text-zinc-600' },
        recruiting: { label: '모집중', cls: 'bg-blue-50 text-blue-700' },
        evaluating: { label: '평가중', cls: 'bg-amber-50 text-amber-700' },
        operating: { label: '운영중', cls: 'bg-emerald-50 text-emerald-700' },
        completed: { label: '완료', cls: 'bg-zinc-100 text-zinc-700' },
        closed: { label: '종료', cls: 'bg-zinc-200 text-zinc-500' },
    };

    public moduleStatusMap: any = {
        active: { label: '진행중', cls: 'bg-emerald-50 text-emerald-700' },
        planned: { label: '예정', cls: 'bg-blue-50 text-blue-700' },
        ongoing: { label: '진행중', cls: 'bg-emerald-50 text-emerald-700' },
        done: { label: '완료', cls: 'bg-zinc-100 text-zinc-700' },
        closed: { label: '종료', cls: 'bg-zinc-100 text-zinc-500' },
    };

    public async ngOnInit() {
        await this.service.init();
        const { code, data } = await wiz.call('summary');
        if (code == 200) this.data = data.data;
        this.loaded = true;
        await this.service.render();
    }

    public statusInfo(s: string) { return this.statusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' }; }
    public moduleStatusInfo(s: string) { return this.moduleStatusMap[s] || this.statusInfo(s); }

    public goProgram(p: any) { this.service.href(`/admin/support/programs/${p.id}/operations`); }
    public goProgramInfo(p: any, event?: Event) {
        if (event) event.stopPropagation();
        this.service.href(`/admin/support/programs/${p.id}/info`);
    }
    public goPrograms() { this.service.href('/admin/support/programs'); }
    public goApplications() { this.service.href('/admin/support/applications'); }
    public goEvaluators() { this.service.href('/admin/support/evaluators'); }
    public goModules() { this.service.href('/admin/support/modules'); }

    public formatMoney(n: any): string {
        const v = Number(n) || 0;
        return v.toLocaleString();
    }

    public progressWidth(v: any): number {
        const n = Number(v) || 0;
        return Math.max(0, Math.min(100, n));
    }

    public scheduleText(s: any): string {
        const start = s?.start_at || s?.start_date || '';
        const end = s?.end_at || s?.end_date || '';
        if (start && end && start !== end) return `${start} ~ ${end}`;
        return start || end || '일정 미정';
    }

    public schedulePlace(s: any): string {
        return s?.location || '';
    }
}

export default PortalLpsysadminSupportDashboardComponent;